import { render, staticRenderFns } from "./settingBatch.vue?vue&type=template&id=76b66806&scoped=true&"
import script from "./settingBatch.vue?vue&type=script&lang=js&"
export * from "./settingBatch.vue?vue&type=script&lang=js&"
import style0 from "./settingBatch.vue?vue&type=style&index=0&id=76b66806&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b66806",
  null
  
)

export default component.exports